import { useTenantedApplicationConfig } from '../../../contexts/tenantedApplicationConfig';
import { WorkflowConfig } from '../../../types';
import { useWorkflowNameOrFail } from '../useWorkflowNameOrFail';

export const useActiveWorkflowConfig = (): WorkflowConfig => {
  const config = useTenantedApplicationConfig();
  const workflowName = useWorkflowNameOrFail();

  return config.getWorkflowConfig(workflowName);
};
